const STUDIO_URL = "/studio";
export const URLS = {
  ACCOUNT_SETTINGS: "accountsettings",
  ALLSTAR_GAMERS_CLUB: "/allstar/gamersclub",
  CLIPS: "/clips",
  COMPETITION: "/competitions",
  CONNECTED_ACCOUNTS: "/connectedaccounts",
  CS2_MATCH_HISTORY: "/match-history#counter-strike-2",
  CURRENT_COMPETITION: "/competitions/clout-grid-competition",
  DASHBOARD: "dashboard",
  DEV: "/dev",
  FORTNITE_MATCH_HISTORY: "/match-history#fortnite",
  LEAGUE_MATCH_HISTORY: "/match-history#league-of-legends",
  LOGIN: "/login",
  MATCH_HISTORY: "/match-history",
  MONTAGE: "/montages/create",
  NFLUENCE: "/nfluence",
  NOT_FOUND: "/404",
  OAUTH_REDIRECT: "connectedaccounts",
  OVERWOLF: "/overwolf",
  OW2_MATCH_HISTORY: "/match-history#overwatch-2",
  PARTNERS: "/partner/claim",
  PROFILE: "/profile",
  REMIX: "/remix",
  ROOT: "/",
  SETUP: "/setup",
  SIGNUP: "/signup",
  SOCIAL: "/connectedaccounts",
  START: "/start",
  STUDIO: STUDIO_URL,
  STUDIO_CARD: `${STUDIO_URL}/:cardId`,
  SUPPORT: "/support",
  TEAMS: "/teams",
  UPGRADE: "/upgrade",

  AUTH_ROUTES: {
    BATTLENET: "/authenticate/battlenet",
    DISCORD: "/authenticate/discord",
    EPIC: "/authenticate/epic",
    FACEIT: "/authenticate/faceit",
    GOOGLE: "/authenticate/google",
    RIOT: "/authenticate/riot",
    STEAM: "/authenticate/steam",
    TIKTOK: "/authenticate/tiktok",
  },
};

export const TIER_STRING_MAP: { [key: number]: string } = {
  500: "Mythic",
  400: "Legendary",
  300: "Rare",
  200: "Premium",
  100: "Standard",
};

export const TIER_USERGROUP_MAP: { [key: number]: string } = {
  500: "Creator Platinum", // mythic
  400: "Creator Platinum", // legendary
  300: "Pro Plus", // rare
  200: "Pro", // premiumm
  100: "Pro", // standard
};

export const CLIP_GAME_MAP: { [key: string]: string } = {
  CS2: "7302",
  CSGO: "730",
  DOTA2: "570",
  LOL: "101",
  FORTNITE: "407",
};

export const getMomentGameName = (gameKey: string): string => {
  const MOMENT_GAME_MAP: Record<string, string> = {
    CS2: "CS2",
    CS_GO: "CS:GO",
    DOTA2: "Dota 2",
    FORTNITE: "Fortnite",
    LOL: "LoL",
    OW2: "OW2",
  };

  return MOMENT_GAME_MAP[gameKey] || gameKey;
};
